import React, { useEffect, useRef, useState } from 'react';
import Text from '../../../../global/text/text';
import DateFilter from './date-filter/date-filter';
import ReportsViewModel from '../../_reports/reports.viewmodel';
import { ConfigurationFilterType, IReportFilterItem, IReportOperator } from '../../../../../api/reports.dao';
import './report-filter.scss';
import { ReportConfigurationViewModel } from '../../_reports/report-configuration/report-configuration.viewmodel';
import CheckboxFilter from './checkbox-filter/checkbox-filter';
import SearchFilter from './search-filter/search-filter';
import { MeetingsFilter } from './meetings-filter/meetings-filter';
import NumberFilter from './number-filter/number-filter';
import DateTimeFilter from './date-time-filter/date-time-filter';

interface IProps {
    type: ConfigurationFilterType;
    field: string;
    label: string;
    items?: IReportFilterItem[];
    placeholder?: string;
    additionalLabel?: string;
    vm: ReportsViewModel;
    configurationVm: ReportConfigurationViewModel;
    defaultOperator?: IReportOperator;
}

const ReportFilter = (props: IProps) => {
    const {
        type,
        field,
        label,
        items,
        placeholder,
        additionalLabel,
        vm,
        configurationVm,
        defaultOperator
    } = props;

    const [headerHeight, setHeaderHeight] = useState('100%');
    const headerRef = useRef(null);

    useEffect(() => {
        if (headerRef.current) {
            setHeaderHeight(`calc(100% - ${headerRef.current.clientHeight}px`);
        }
    }, [headerRef.current]);

    const ReportFilterHeader = () => (
        <div className='report-filter-header'>
            <Text className='generate-event-report__filter-name' message={label} />
        </div>
    );

    const commonProps = {
        field: field,
        configurationVm: configurationVm,
        ContentHeader: <ReportFilterHeader />,
        headerHeight: headerHeight,
        headerRef: headerRef
    };

    if (type === ConfigurationFilterType.DATE) {
        return <DateFilter {...commonProps} vm={vm} />;
    }
    if (type === ConfigurationFilterType.CHECKBOX) {
        return <CheckboxFilter {...commonProps} items={items} />;
    }
    if (type === ConfigurationFilterType.MEETINGS) {
        return <MeetingsFilter {...commonProps} vm={vm.meetingsFilterVM} />;
    }
    if (type === ConfigurationFilterType.SEARCH) {
        return <SearchFilter
            placeholder={placeholder}
            defaultOperator={defaultOperator}
            {...commonProps}
        />;
    }
    if (type === ConfigurationFilterType.NUMBER) {
        return <NumberFilter {...commonProps} additionalLabel={additionalLabel} />;
    }
    if (type === ConfigurationFilterType.DATE_TIME) {
        return <DateTimeFilter {...commonProps} />;
    }
};

export default ReportFilter;
